import type { DistributionApiResponse } from '@/features/Distribution/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class DistributionHttpService extends HttpService {
  loadDistributionOptions(
    insuranceId: string,
    calculationId: string,
  ): HttpClientResponse<DistributionApiResponse> {
    return this.httpClient.get(`gesellschaften/${insuranceId}/vertriebswege`, {
      params: {
        berechnungsId: calculationId,
      },
    });
  }

  saveChannelSelection(
    insuranceId: string,
    channelId: string,
  ): HttpClientResponse<never[]> {
    return this.httpClient.post(`gesellschaften/${insuranceId}/vertriebsweg`, {
      data: {
        targetInsuranceId: channelId,
      },
    });
  }

  callPoolingCallbackUrl(url: string): HttpClientResponse<never> {
    return this.httpClient.post(url, { dontUseBaseUrl: true });
  }
}
